var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-special-needs" }, [
    _c(
      "div",
      { staticClass: "special-needs-wrapper-form p-t-4 p-b-16 p-rl-16 bd-r-8" },
      [
        _c(
          "h2",
          { staticClass: "tls-simple-text -color-main -size-18 -weight-bold" },
          [_vm._v(_vm._s(_vm.subtitle))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "select-wrapper m-tb-16" },
          [
            _c("CustomSelect", {
              attrs: {
                options: _vm.disabilitiesOptions,
                placeholder: _vm.disabilitiesPlaceholder
              },
              model: {
                value: _vm.selectedDisabilities,
                callback: function($$v) {
                  _vm.selectedDisabilities = $$v
                },
                expression: "selectedDisabilities"
              }
            }),
            _vm._v(" "),
            _c("CustomSelect", {
              attrs: {
                options: _vm.applicantsOptions,
                placeholder: _vm.applicantsPlaceholder,
                "show-all-option": true
              },
              model: {
                value: _vm.selectedApplicants,
                callback: function($$v) {
                  _vm.selectedApplicants = $$v
                },
                expression: "selectedApplicants"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.selectedDisabilities.length
          ? _c(
              "div",
              { staticClass: "flex ai-center wrap g-16 m-b-16" },
              _vm._l(_vm.selectedDisabilities, function(disability, index) {
                return _c("DisabilityBadge", {
                  key: index,
                  attrs: {
                    disability: disability.title,
                    icon: disability.icon
                  },
                  on: { removeDisability: _vm.removeDisability }
                })
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.comment,
              expression: "comment"
            }
          ],
          staticClass: "tls-input-text ws-nowrap to-ellipsis",
          attrs: { type: "text", placeholder: _vm.commentPlaceholder },
          domProps: { value: _vm.comment },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.comment = $event.target.value
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex ai-center jc-center g-16 m-t-24" }, [
      _c(
        "button",
        {
          staticClass: "button-link-neo-inside",
          on: {
            click: function($event) {
              return _vm.$emit("input")
            }
          }
        },
        [
          _vm._v(
            "\n           " +
              _vm._s(_vm._.get(_vm.keywords, "cancel")) +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button-neo-inside -primary",
          attrs: { disabled: _vm.disableConfirmButton },
          on: {
            click: function($event) {
              return _vm.$emit("input", _vm.specialNeedsPayload)
            }
          }
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm._.get(_vm.keywords, "confirm")) +
              "\n        "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }